import React from 'react'
import './Comp.css'
function Comp({key , url, name, description , rating}) {
  return (
    <div key={key}  className="review-card">
      <div className='review-card-inner'>
      <img src={url} alt={name} className="review-image" />
      <h3>{name}</h3>
      <p>{description}</p>
      <div className="review-rating">Rating: {rating} / 5</div>
      </div>
    </div>
  )
}

export default Comp;